export default __webpack_public_path__ + "static/media/visible-on.82091a5a.svg";